import React, {useEffect} from "react";
import "./App.css";
import Index from "./Content";
import "bootstrap/dist/css/bootstrap.min.css";
import icon from './assets/logo.png';

function App() {
  useEffect(() => {
    const favicon = document.getElementById('favicon');
    favicon.setAttribute('href', icon);
  }, []);
  return (
    <div>
      <Index />
    </div>
  );
}

export default App;
